import React from 'react';

import style from './PortletTitle.scss';

export const PortletTitle = ({ portlet }) => {
    const { title, showTitle } = portlet;

    if (!showTitle || !title) {
        return null;
    }

    return (
        <h1 className={`${style.title} fn-portlet-title`}>{title}</h1>
    );
};
